import { ChangeEventHandler, FC, RefObject } from 'react';
import { TimeshiftAvatar } from '../../../../components/shared/TimeshiftAvatar';
import { Button } from '../../../../components/shared/button/Button';
import { TSTitleCard } from '../../../../components/shared/card/Card';
import strings from '../../team.translations';
import { TSTitleCardStyle } from '../AddSingleTeamMemberForm';

interface EmployeeAvatarEditCardProps {
  avatarUrl?: string;
  employeeName: string;
  fileInputRef: RefObject<HTMLInputElement | null>;
  loadingRemove?: boolean;
  loadingUpload?: boolean;
  onAvatarSelected: ChangeEventHandler<HTMLInputElement>;
  onRemoveAvatar: () => void;
}

export const EmployeeAvatarEditCard: FC<EmployeeAvatarEditCardProps> = ({
  avatarUrl,
  employeeName,
  fileInputRef,
  loadingRemove,
  loadingUpload,
  onAvatarSelected,
  onRemoveAvatar
}) => {
  return (
    <TSTitleCard title={strings.editTeamMember.avatarTitle} className={TSTitleCardStyle}>
      <div className="flex flex-col items-center gap-4 py-2 sm:flex-row sm:items-end sm:justify-between">
        <TimeshiftAvatar name={employeeName} size={96} src={avatarUrl} />
        <div className="flex flex-col gap-3 sm:min-h-[96px] sm:justify-end sm:items-end">
          <input
            ref={fileInputRef}
            accept="image/jpeg,image/png"
            className="hidden"
            onChange={onAvatarSelected}
            type="file"
          />
          <div className="flex w-full gap-3 sm:w-auto">
            <Button
              className="inline-flex items-center justify-center flex-1 sm:min-w-[120px]"
              loading={loadingUpload}
              onClick={() => fileInputRef.current?.click()}
              primary
            >
              {strings.editTeamMember.uploadAvatar}
            </Button>
            {avatarUrl && (
              <Button
                className="inline-flex items-center justify-center flex-1 sm:min-w-[120px]"
                danger
                loading={loadingRemove}
                onClick={onRemoveAvatar}
              >
                {strings.editTeamMember.removeAvatar}
              </Button>
            )}
          </div>
          <p className="text-sm text-secondary-std sm:text-right">{strings.editTeamMember.avatarHelpText}</p>
        </div>
      </div>
    </TSTitleCard>
  );
};
